import React from 'react';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

const VideoPlayer = ({ sourceUrl, autoplay = false }) => {
  return (
    sourceUrl && (
      <video
        className="video__desktop"
        controls
        controlsList="nodownload"
        autoPlay={autoplay}
        disablePictureInPicture
      >
        <source src={replaceWithJioCDN(sourceUrl)} />
      </video>
    )
    // <source src="https://player.vimeo.com/external/436729664.sd.mp4?s=b91833a1ab4ca6ed9b7a3620790ee42cd31b150b&profile_id=165" />
  );
};

export default VideoPlayer;
